import type { Transfer } from '@0xtorch/core'
import type { Chain } from '../../chain'
import type { BlockEvent } from '../../types'
import {
  createAssetsBurnedTransfer,
  createAssetsIssuedTransfer,
  createAssetsTransferredTransfer,
  createBalancesBurnedTransfer,
  createBalancesDepositTransfer,
  createBalancesMintedTransfer,
  createBalancesTransferTransfer,
  createBalancesWithdrawTransfer,
  createTokensDepositedTransfer,
  createTokensTransferTransfer,
  createTokensWithdrawnTransfer,
} from './createTransfer'

export const createGeneralTransfers = (params: {
  chain: Chain
  events: readonly BlockEvent[]
  relatedAddresses: Set<string>
  debug?: (message: unknown) => void
}): readonly Transfer[] => {
  const { chain, events, relatedAddresses, debug } = params
  const transfers: Transfer[] = []

  for (const event of events) {
    switch (event.section) {
      case 'assets': {
        switch (event.method) {
          case 'Burned': {
            const transfer = createAssetsBurnedTransfer({
              chain,
              data: event.data,
              relatedAddresses,
              debug,
            })
            if (transfer !== undefined) {
              transfers.push(transfer)
            }
            break
          }
          case 'Issued': {
            const transfer = createAssetsIssuedTransfer({
              chain,
              data: event.data,
              relatedAddresses,
              debug,
            })
            if (transfer !== undefined) {
              transfers.push(transfer)
            }
            break
          }
          case 'Transferred': {
            const transfer = createAssetsTransferredTransfer({
              chain,
              data: event.data,
              relatedAddresses,
              debug,
            })
            if (transfer !== undefined) {
              transfers.push(transfer)
            }
            break
          }
          default: {
            break
          }
        }
        break
      }
      case 'balances': {
        switch (event.method) {
          case 'Burned': {
            const transfer = createBalancesBurnedTransfer({
              chain,
              data: event.data,
              relatedAddresses,
              debug,
            })
            if (transfer !== undefined) {
              transfers.push(transfer)
            }
            break
          }
          case 'Deposit': {
            const transfer = createBalancesDepositTransfer({
              chain,
              data: event.data,
              relatedAddresses,
              debug,
            })
            if (transfer !== undefined) {
              transfers.push(transfer)
            }
            break
          }
          case 'Minted': {
            const transfer = createBalancesMintedTransfer({
              chain,
              data: event.data,
              relatedAddresses,
              debug,
            })
            if (transfer !== undefined) {
              transfers.push(transfer)
            }
            break
          }
          case 'Transfer': {
            const transfer = createBalancesTransferTransfer({
              chain,
              data: event.data,
              relatedAddresses,
              debug,
            })
            if (transfer !== undefined) {
              transfers.push(transfer)
            }
            break
          }
          case 'Withdraw': {
            const transfer = createBalancesWithdrawTransfer({
              chain,
              data: event.data,
              relatedAddresses,
              debug,
            })
            if (transfer !== undefined) {
              transfers.push(transfer)
            }
            break
          }
          default: {
            break
          }
        }
        break
      }
      case 'tokens': {
        switch (event.method) {
          case 'Deposited': {
            const transfer = createTokensDepositedTransfer({
              chain,
              data: event.data,
              relatedAddresses,
              debug,
            })
            if (transfer !== undefined) {
              transfers.push(transfer)
            }
            break
          }
          case 'Transfer': {
            const transfer = createTokensTransferTransfer({
              chain,
              data: event.data,
              relatedAddresses,
              debug,
            })
            if (transfer !== undefined) {
              transfers.push(transfer)
            }
            break
          }
          case 'Withdrawn': {
            const transfer = createTokensWithdrawnTransfer({
              chain,
              data: event.data,
              relatedAddresses,
              debug,
            })
            if (transfer !== undefined) {
              transfers.push(transfer)
            }
            break
          }
          default: {
            break
          }
        }
        break
      }
      default: {
        break
      }
    }
  }

  return transfers
}
